import 'firebase/auth'

import { config } from '../config'

const app = require('firebase/app')

export const firebase = app.initializeApp(config.firebase, 'app')

export default firebase
